module.exports = __webpack_public_path__ + "static/img/video-pass.47513863.png";